import React from 'react'
import iconPaths from '../../style/lux-icons/selection.json'

const LuxIcon = (props: {
    icon: string
    size?: number
    color?: string
    classes?: string
}) => {
    const { size, icon, color, classes } = props

    const icon_ = iconPaths.icons.find((i) => i.properties.name === icon)

    if (icon_)
        return (
            <i
                className={`${classes ? classes : ''} pi`}
                style={{ display: 'contents' }}>
                <svg
                    viewBox={'0 0 1024 1024'}
                    width={size ? size : '14'}
                    height={size ? size : '14'}
                    fill={color ? color : 'black'}
                    style={{ overflow: 'visible', color: color }}>
                    <path d={icon_.icon.paths.join(' ')}></path>
                </svg>
            </i>
        )
    else
        return (
            <i
                className={`pi pi-${icon} ${classes}`}
                style={{ color: color, fontSize: size + 'px' }}></i>
        )
}

export default LuxIcon
